import { render, staticRenderFns } from "./PropertyOwnerForm.vue?vue&type=template&id=0da23f63&"
import script from "./PropertyOwnerForm.vue?vue&type=script&lang=ts&"
export * from "./PropertyOwnerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports